export default "__VITE_ASSET__DQWqantB__"